import { Button } from "primereact/button";

const DownloadApplicationSection = () => {
    return (
        <div className="flex flex-wrap justify-content-center xl:justify-content-evenly align-items-center px-4 md:px-8 py-8" style={{
            width: "100%",
            minHeight: "100vh",
            backgroundImage: "url('/ApplicationsImage.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}
        >
            <div style={{ position: "relative"}}>
                <img src="/ApplicationPhoneImage.png" className="w-30rem px-6 xl:px-0 py-8 xl:py-0 flex-grow-1" style={{ position: "relative", zIndex: 2 }} />
                <img src="/RedArea.png" className="px-8 w-30rem flex-grow-1" style={{ position: "absolute", top: "12rem", zIndex: 1, right: "0.1rem" }} />
            </div>

            <div className="flex flex-column gap-6">
                <p className="m-0 text-lg" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >STORE</p>
                <div className="">
                    <p className="m-0 font-bold" style={{ color: "#2D3967", fontSize: "3.25rem" }} >Anytime,</p>
                    <p className="m-0 font-bold" style={{ color: "#E3506B", fontSize: "3.25rem" }} >Anywhere!</p>
                </div>
                <p className="m-0 text-xl xl:w-30rem" style={{ color: "#727A99", textWrap: "wrap" }} >
                    Recover wherever you are with
                    Mobithera’s AI-powered physical
                    therapy app.
                    Access clinician-assigned exercises,
                    receive real-time movement feedback,
                    and stay on track, right from your
                    device.
                </p>

                <p className="text-xl m-0" style={{color: "#2D3967", fontWeight: "bold"}}>
                    Download the app and start your <br />
                    journey toward smarter, safer recovery.
                </p>

                <div className="flex flex-wrap justify-content-center xl:justify-content-start gap-4">
                    <Button
                        style={{
                            color: "white",
                            backgroundColor: "#E3506B",
                            borderRadius: "10px",
                            height: "3.5rem",
                            width: "11rem",
                            display: "flex",
                            justifyContent: "center"
                        }} >
                        <div className="flex align-items-center">
                            <img src="/AppStoreLogo.svg" />
                        </div>
                    </Button  >

                    <Button
                        style={{
                            color: "white",
                            backgroundColor: "#2D3967",
                            borderRadius: "10px",
                            height: "3.5rem",
                            width: "11rem",
                            display: "flex",
                            justifyContent: "center"
                        }}  >
                        <div className="flex  align-items-center">
                            <img src="/GoogleLogo.svg" />
                        </div>
                    </Button  >
                </div>
            </div>
        </div>
    )
}

export default DownloadApplicationSection;